import { css } from "@compiled/react";

import { media } from "@atlaskit/primitives";
import { token } from "@atlaskit/tokens";

import { Adg4Skeleton } from "@/components/adg4/skeleton/src/skeleton";

const headingSectionGap = css({
    marginBlockEnd: token("space.100")
});

const sectionGap = css({
    marginBlockEnd: token("space.600"),
    [media.below.md]: {
        marginBlockEnd: token("space.400")
    }
});

const containerStyles = css({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center"
});

const mobileDisplay = css({
    display: "none",
    [media.below.md]: {
        display: "block"
    }
});

const desktopDisplay = css({
    display: "block",
    [media.below.md]: {
        display: "none"
    }
});

export const HeroCTASkeleton = () => {
    return (
        <div
            data-testid="hero-cta-skeleton"
            css={css({ marginBlockStart: token("space.600") })}
        >
            <div css={desktopDisplay}>
                <div css={containerStyles}>
                    <div css={[headingSectionGap]}>
                        <Adg4Skeleton width="566px" height="64px" />
                    </div>
                    <div css={sectionGap}>
                        <Adg4Skeleton width="770px" height="64px" />
                    </div>
                    <div css={sectionGap}>
                        <Adg4Skeleton width="168px" height="40px" />
                    </div>
                    <div css={sectionGap}>
                        <Adg4Skeleton width="1140px" height="509px" />
                    </div>
                </div>
            </div>
            <div css={mobileDisplay}>
                <div css={containerStyles}>
                    <div css={[headingSectionGap]}>
                        <Adg4Skeleton width="147px" height="64px" />
                    </div>
                    <div css={sectionGap}>
                        <Adg4Skeleton width="311px" height="64px" />
                    </div>
                    <div css={sectionGap}>
                        <Adg4Skeleton width="141px" height="40px" />
                    </div>
                    <div css={sectionGap}>
                        <Adg4Skeleton width="311px" height="509px" />
                    </div>
                </div>
            </div>
        </div>
    );
};
